import * as React from "react"
import styled from "styled-components"
import { Flex, Text } from ".."
import { colors } from "../../styles/constants/colors"
import { scale } from "../../styles/utils/calc"

interface OvalCardImageProps {
	backgroundImage: string
}
export interface OvalCardProps extends OvalCardImageProps {
	title: string
}

const OvalCardStyled = styled.div`
	background-color: ${colors.navy};
	height: ${scale.px(102 / 8)};
	border-radius: ${scale.px(3)};
	width: 100%;
	display: flex;
	overflow: hidden;
	flex-direction: column;
	hyphens: auto;
	border: 1px solid ${colors.white};

	a:hover & {
		border: 1px solid ${colors.hoverBlue};
	}
`

const OvalCardImage = styled.div<OvalCardImageProps>`
	background-image: url(${(props) => props.backgroundImage});
	background-position: center;
	background-size: cover;
	min-height: 66px;
	width: 100%;
`
const OvalCard: React.FC<OvalCardProps> = (props) => {
	return (
		<OvalCardStyled>
			<OvalCardImage backgroundImage={props.backgroundImage} />
			<Flex alignSelf="center" alignItems="center" h={1}>
				<Text
					truncate="twoLine"
					fontSize={1.5}
					fontWeight="bold"
					letterSpacing={1 / 8}
					lineHeight={1.75}
					mb={0}
					px={2.5}
					textColor="white"
					textTransform="uppercase"
					textAlign="center"
				>
					{props.title}
				</Text>
			</Flex>
		</OvalCardStyled>
	)
}

export { OvalCard }
